export class StringFormat {

    static joinSpaceForCapitalLetters(string: String): String | null {
        if (string) {
            return string.split(/(?=[A-Z])/).join(" ");
        }
        return null;
    }
}